import React, { useState, useEffect, useContext } from "react";

import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { useParams, Link, useHistory, useLocation } from "react-router-dom";
import { BsCreditCard } from "react-icons/bs";
import { FaPiggyBank } from "react-icons/fa";
import { BsExclamationCircle } from "react-icons/bs";
import { MdContentCopy } from "react-icons/md";
import { CoinContext } from "../../contexts/CoinContext";
import * as Sentry from "@sentry/react";
import { REACT_APP_PROD_URL } from "../../services/configs";
import useResizer from "../../services/useResizer";
import Icon from "../../fontIcons/icon";
import styled from "styled-components";
import { useSelector } from "react-redux";
import qs from "query-string";
import useSWR from "swr";
import fetcher from "../../api/swr_fetcher";
import { Divider } from "@material-ui/core";
import ReactMarkdown from "react-markdown";
import { ScheduleOutlined } from "@material-ui/icons";
import mobikwik from "../../assets/icons/mobikwik.png";

export default function DepositCard(props) {
  const isMobile = useResizer();
  const classes = useStyles();
  const { handleClickAlert, bannedTimeout } = useContext(CoinContext);

  function getStatus(status) {
    switch (status) {
      case "ACTIVE":
        return (
          <div className="flex items-center font-light">
            <div className={classes.greenDot}></div>
            <p>Active</p>
          </div>
        );
        break;
      case "PAUSED":
        return (
          <div className="flex items-center font-light">
            <div className={classes.yellowDot}>
              <ScheduleOutlined
                style={{ width: "16px", height: "16px" }}
              ></ScheduleOutlined>
            </div>
            <p>Paused</p>
          </div>
        );
        break;
    }
  }
  return (
    <Link to={props.status == "ACTIVE" ? props.to : "#"}>
      <div
        className={`${classes.card} mb-4 unselectable ${
          props.status != "ACTIVE"
            ? "opacity-50"
            : " shimmer-button cursor-pointer"
        } dark:bg-[#161921] bg-gray-200  p-5`}
      >
        <div className="flex items-center mb-2">
          {props.title.toLowerCase().includes("mobikwik") && (
            <img
              src={mobikwik}
              style={{ width: "24px", marginRight: "8px" }}
            ></img>
          )}
          <h3 className="mr-3">{props.title}</h3>
          <div className="flex items-center   ">{getStatus(props.status)}</div>
        </div>
        <p className="mb-2">{props.content}</p>
        <strong>
          <p>{props.subtitle}</p>
        </strong>
      </div>
    </Link>
  );
}

const useStyles = makeStyles((theme) => ({
  greenDot: {
    width: "10px",
    height: "10px",
    background: "#1DCF9A",
    borderRadius: "50%",
    marginRight: "5px",
  },
  yellowDot: {
    display: "flex",
    alignItems: "center",
    color: "#DFBE68",
    marginRight: "5px",
  },
  card: {
    boxShadow: "4px 5px 2px rgba(0, 0, 0, 0.2)",
    borderRadius: "10px",
    "&:hover:after": {
      backgroundColor: "rgba(255,255,255,0)",
      WebkitTransition: "all 0.4s ease-in-out",
      MozTransition: "all 0.4s ease-in-out",
      transition: "all 0.4s ease-in-out",
    },
  },
}));
